import React, { useEffect, useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { Button, Form, Spin, message, Tabs, Col, Input } from 'antd';
import { ArrowLeftOutlined, SaveOutlined } from '@ant-design/icons';
import axios from '../utils/axios';
import BreadCrumb from '../components/Breadcrumb';

function PrivacyPolicyAddEdit() {
	const navigate = useNavigate();
	const { editPrivacyId } = useParams();
	const [isLoading, setIsLoading] = useState(false);
	const [form] = Form.useForm();

	// Fetch existing data when editing
	const get = () => {
		if (!editPrivacyId) return;

		setIsLoading(true);
		axios
			.get(`/privacy-policy`, { params: { _id: editPrivacyId } })
			.then((result) => {
				if (Array.isArray(result.data.data) && result.data.data.length) {
					const [data] = result.data.data;
					form.setFieldsValue(data);
				}
			})
			.catch(() => {})
			.finally(() => setIsLoading(false));
	};

	// Save handler
	const onSave = () => {
		form.validateFields()
			.then((values) => {
				setIsLoading(true);
				if (editPrivacyId) values._id = editPrivacyId;

				axios({
					method: editPrivacyId ? 'put' : 'post',
					url: '/privacy-policy',
					data: values,
				})
					.then((result) => {
						if (result.data.success) {
							message.success(result.data.message);
							navigate('/privacy');
						} else {
							message.error(result.data.message);
							setIsLoading(false);
						}
					})
					.catch(() => {
						message.error('Oops! Something went wrong!');
						setIsLoading(false);
					});
			})
			.catch((e) => console.log(e));
	};

	useEffect(() => {
		get();
	}, []);

	return (
		<>
			<BreadCrumb breadcrumbs={[{ link: '/', label: 'Home' }, { label: 'Privacy Policy' }]} />
			<Spin spinning={isLoading}>
				<div className='main-content'>
					<div className='page-header'>
						<div className='page-title'>{editPrivacyId ? 'Edit Privacy Policy' : 'Add Privacy Policy'}</div>
						<div className='page-title-more'>
							<Link to='/privacy'>
								<Button icon={<ArrowLeftOutlined />}>Back</Button>
							</Link>
							<Button icon={<SaveOutlined />} type='primary' onClick={onSave} loading={isLoading}>
								Save
							</Button>
						</div>
					</div>

					<div className='form-content'>
						<Form form={form} layout='vertical' autoComplete='off'>
							<Tabs
								defaultActiveKey='1'
								items={[
									{
										key: 'Details',
										label: 'Privacy Policy Details',
										children: (
											<>
												<Col sm={24} md={24}>
													<Form.Item label='Title' name='title' rules={[{ required: true, message: 'Title is required' }]}>
														<Input placeholder='Enter policy title' />
													</Form.Item>
												</Col>

												<Col sm={24} md={24}>
													<Form.Item label='Content' name='content' rules={[{ required: true, message: 'Content is required' }]}>
														<Input.TextArea rows={10} placeholder='Enter privacy policy content' />
													</Form.Item>
												</Col>
											</>
										),
									},
								]}
							/>
						</Form>
					</div>
				</div>
			</Spin>
		</>
	);
}

export default PrivacyPolicyAddEdit;
